import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Form as AntForm } from 'antd';
import { Column, Form, Input, Row, Text, Button } from '@bancobarigui/barihaus';
import { isValidCPFOrCNPJ, formatCPFOrCNPJ, cleanDocument } from '@/utils/documentValidation';
import { MaskedInput } from '@/shared/components/MaskedInput';

export function ProponentForm() {
  const form = AntForm.useFormInstance();

  const handleDocumentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleanValue = cleanDocument(value);

    if (cleanValue.length <= 14) {
      const formatted = formatCPFOrCNPJ(value);
      form.setFieldsValue({ document: formatted });
    }
  };

  return (
    <Row gutter={[24, 16]}>
      <Column span={24}>
        <Form.Item
          name="name"
          label="Proponente"
          rules={[{ required: true, message: 'Informe o nome do proponente.' }]}
        >
          <Input placeholder="Nome completo ou Razão Social" />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          name="document"
          label="CPF/CNPJ"
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.reject("Informe o CPF ou CNPJ");
                if (isValidCPFOrCNPJ(value)) {
                  return Promise.resolve();
                }
                return Promise.reject('CPF ou CNPJ inválido');
              },
            },
          ]}
        >
          <Input
            placeholder="000.000.000-00 ou 00.000.000/0000-00"
            className="w-full"
            onChange={handleDocumentChange}
            maxLength={18}
          />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[{ type: 'email', message: 'E-mail inválido', required: true }]}
        >
          <Input placeholder="contato@exemplo.com" type="email" />
        </Form.Item>
      </Column>

      <Column span={24}>
        <Text>* Telefones</Text>
        <AntForm.List name="phones" initialValue={[{}]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => (
                <div key={field.key} className="flex gap-2 mb-2">
                  <Form.Item
                    {...field}
                    name={[field.name, 'phone']}
                    rules={[{ required: true, message: 'Informe um telefone.' }]}
                    className="flex-grow"
                    style={{ marginBottom: 0 }}
                  >
                    <MaskedInput mask="(00) 00000-0000" placeholder="(00) 00000-0000" autoComplete="tel" />
                  </Form.Item>

                  {fields.length > 1 && (
                    <Button
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => remove(field.name)}
                      style={{ flexShrink: 0 }}
                    >
                      Deletar
                    </Button>
                  )}
                </div>
              ))}
              <Button
                type="dashed"
                onClick={() => add()}
                icon={<PlusOutlined />}
                className="w-full mt-2"
              >
                Adicionar telefone
              </Button>
            </>
          )}
        </AntForm.List>
      </Column>
    </Row>
  );
}
